<mat-list>
  <h3 mat-subheader>Navigatie</h3>
</mat-list>

<mat-accordion displayMode="flat" id="navigation">
  <mat-expansion-panel *ngIf="_Global.hasGUIPermission('Dashboard')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>home</mat-icon>
        <span style="width: 100%; text-align: center;">Dashboard</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-list>
      <mat-list-item>
        <button mat-button appLink link="/dashboard">Overview</button>
      </mat-list-item>
      <mat-list-item>
        <button appLink link="/dashboard/dealers" mat-button>Dealers</button>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="_Global.hasGUIPermission('Crm')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>people</mat-icon>
        <span style="width: 100%; text-align: center;">CRM</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list>
      <mat-list-item>
        <button mat-button appLink link="/crm">Relations</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button appLink link="/crm/addresses">Addresses</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button appLink link="/crm/contacts">Contacts</button>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="_Global.hasGUIPermission('Activations')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>trending_up</mat-icon>
        <span style="width: 100%; text-align: center;">Activations</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list>
      <mat-list-item>
        <button mat-button appLink link="/activation/dashboard">Dashboard</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button appLink link="/activation/overview">Overview</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button appLink link="/activation/agenda">Agenda</button>
      </mat-list-item>
      <mat-list-item>
        <button [matBadge]="(numStudentsToModerate | async)?.count" [queryParams]="{IsActive: false, Role: ['Student']}" matBadgePosition="after"
                appLink link="/settings/students" mat-button>
          Students
        </button>
      </mat-list-item>

    </mat-list>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="_Global.hasGUIPermission('Documents')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>description</mat-icon>
        <span style="width: 100%; text-align: center;">Documents</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list>
      <mat-list-item *ngFor="let documentType of _Global.Division?.DocumentTypes">
        <button mat-button appLink [link]="['/documents', documentType.Id]">{{documentType.Title}}</button>
      </mat-list-item>
      <mat-list-item>
        <button appLink link="/documents/line-search" mat-button>Line Search</button>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="_Global.hasGUIPermission('Reseller')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>pets</mat-icon>
        <span style="width: 100%; text-align: center;">Reseller</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list>
      <mat-list-item>
        <button mat-button appLink link="/reseller/promotions">Promotions</button>
      </mat-list-item>
      <mat-list-item>
        <button appLink link="/reseller/codes" mat-button>Codes</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button appLink link="/reseller/groups">Groups</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button appLink link="/reseller/price-lists">Price Lists</button>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="_Global.hasGUIPermission('Student_Activations')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>trending_up</mat-icon>
        <span style="width: 100%; text-align: center;">Student&#64;Work</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list>
      <mat-list-item>
        <button mat-button appLink link="/activation-student/dashboard">Dashboard</button>
      </mat-list-item>
      <mat-list-item>
        <button [matBadge]="(numActivationsToModerate | async)?.count" appLink link="/activation-student/overview"
                mat-button>Overview
        </button>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="_Global.hasGUIPermission('Warehouse')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>shopping_cart</mat-icon>
        <span style="width: 100%; text-align: center;">Warehouse</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list>
      <mat-list-item>
        <button mat-button appLink link="/warehouse/articles">Articles</button>
      </mat-list-item>
      <mat-list-item>
        <button appLink link="/warehouse/locations" mat-button>Supply plants</button>
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>

</mat-accordion>
